import { Base } from "./categoryLinks.base";
import { Link } from "./components/link";

export const CategoryLinks = Object.assign(Base, {
    Link: Link
});
